import { Box, Button, ButtonStyled, Icon, IconStyled, inputMediumStyles, TextFieldStyled } from '@bechtel/gds';
import { Link, LinkProps, NavLink } from 'react-router-dom';
import { css, default as styled, default as Styled } from 'styled-components';
import { SearchField } from '@bechtel/client-common';

export const width = '352px';

export interface UserListContainerStyledProps {
  isDrawerOpen: boolean;
}

export const UserListContainerStyled = Styled(Box).attrs({
  flexDirection: { sm: 'column' },
})<UserListContainerStyledProps>`
${({ theme }) => css`
  width: ${width};
  overflow-y: auto;
  border-right: solid 1px ${theme.colors.grey[300]};
`}
${({ isDrawerOpen }) =>
  isDrawerOpen &&
  css`
    &::before {
      box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
      content: '';
      height: 100%;
      pointer-events: none;
      position: absolute;
      right: 0;
      left: calc(${width} - 32px);
      width: 32px;
      z-index: 2;
    }
  `}
`;

export const SearchFieldStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  pl: { sm: '550' },
  pr: { sm: '500' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: ${theme.fontFamilies['graphik']};
    `}
  }
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]}!important;
    color: ${theme.colors.grey[1000]}!important;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      ${inputMediumStyles}
    }
  `}
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: boolean;
}

export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const StyledIcon = styled(Icon)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > svg {
      height: ${({ theme }) => theme.fontSizes[500]};
    }
  }
`;
export const UserItemStyled = styled(Box).attrs({
  px: { sm: '600' },
  pt: { sm: '400' },
  pb: { sm: '400' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) =>
    css`
      border-bottom: solid 1px ${theme.colors.grey['300']};
      color: ${theme.colors.black};
      min-height: 59px;
    `}
`;

export const ListStyled = styled(Box).attrs({
  mt: { sm: '550' },
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) =>
    css`
      border-top: solid 1px ${theme.colors.grey['300']};
      overflow-y: auto;
    `}
`;

export const ButtonBlock = styled(ButtonStyled).attrs({
  as: Link,
})<LinkProps>`
  ${({ theme }) => css`
    width: auto;
    height: auto;
    background-color: transparent;
    color: ${theme.colors.bechtel.blue[800]};
    box-shadow: none;
    &:hover {
      background-color: transparent;
    }
    &:active {
      background-color: transparent;
    }
  `}
`;

export const NavLinkStyled = styled(NavLink)`
  display: block;
  text-decoration: none;
  transition-timing-function: ease-in-out;
  transition-duration: 80ms;
  transition-property: background-color;
  &:active,
  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;
